/**
 * Préconfiguration fiche produit depuis archétype assistant — Lot L-UX-1 étape 4.
 */

import { ARCHETYPE_IDS, getArchetypeById } from '../config/produitArchetypes.js';

/**
 * @param {string} archetypeId
 * @param {Record<string, unknown>} [answers]
 * @returns {Record<string, unknown>}
 */
export function buildArchetypePrefillPatch(archetypeId, answers = {}) {
  const archetype = getArchetypeById(archetypeId);
  if (!archetype) return {};

  const patch = { ...(archetype.prefill ?? {}) };

  if (archetypeId === ARCHETYPE_IDS.PLATEAU_PIECES) {
    if (answers.validationMode) patch.validationMode = answers.validationMode;
    if (answers.incrementPieces) patch.incrementPieces = parseInt(answers.incrementPieces, 10) || 1;
  }

  if (
    archetypeId === ARCHETYPE_IDS.PLANCHE_PERSONNES ||
    archetypeId === ARCHETYPE_IDS.PLANCHE_PERSO
  ) {
    if (answers.minPersons != null) patch.minPersons = Number(answers.minPersons);
    if (answers.maxPersons != null) patch.maxPersons = Number(answers.maxPersons);
  }

  if (archetypeId === ARCHETYPE_IDS.POIDS && answers.unitePoids) {
    patch.unitePoids = answers.unitePoids;
    patch.venteAuPoids = true;
    patch.prix = 0;
  }

  return patch;
}

export {
  isCataloguePrixRequired,
  canSubmitProduitForm,
  getProduitFormBlockingIssues,
} from './produitFormValidation.js';
